import { createAction } from "@reduxjs/toolkit";
import { ImportExtractionStatus } from "../contracts/ImportExtractionStatus";

/** The background extraction reported a status while the app polls it. */
export const extractionProgressed = createAction<ImportExtractionStatus>("assistantImport/extractionProgressed");
